import { graphql } from '~/graphql';
import { useGraphqlMutation } from '~/hooks/useGraphqlMutation';

const chooseOrderPrimaryContactMutation = graphql(`
  mutation ChooseOrderPrimaryContact($orderId: ID!, $userId: ID!) {
    chooseOrderPrimaryContact(orderId: $orderId, userId: $userId) {
      id
      canChoosePrimaryContact
    }
  }
`);

export const useChooseOrderPrimaryContact = () =>
  useGraphqlMutation(chooseOrderPrimaryContactMutation, ['orders']);
